export default {
  title: 'Bienvenido a Referent',
  subtitle: 'Configuremos tu espacio de trabajo',
  logout: 'Cerrar sesión',
  noOrganization: {
    title: 'No se encontró una organización',
    description: 'Contacta a tu administrador para que te agregue a una organización.',
  },
  steps: {
    step1: 'Crear Organización',
    step2: 'Detalles de la Empresa',
  },
  step1: {
    title: 'Crea tu organización',
    description: 'Comienza creando tu espacio de trabajo organizacional',
    organizationName: 'Nombre de la organización',
    organizationNamePlaceholder: 'Mi Empresa S.A.',
    slug: 'Identificador URL',
    slugPlaceholder: 'mi-empresa',
    nameRequired: 'El nombre de la organización es requerido',
    nameMinLength: 'El nombre debe tener al menos 3 caracteres',
    slugRequired: 'El identificador es requerido',
    slugMinLength: 'El identificador debe tener al menos 3 caracteres',
    slugPattern: 'Solo se permiten letras minúsculas, números y guiones',
    slugAvailable: 'Este identificador está disponible',
    slugTaken: 'Este identificador ya está en uso',
    continue: 'Crear y Continuar',
    organizationCreated: 'Organización creada exitosamente',
    errorCreating: 'Error al crear la organización',
  },
  step2: {
    title: 'Completa la información de tu empresa',
    description: 'Completa la información de tu empresa para finalizar el onboarding',
    basicInfo: 'Información Básica',
    companyDetails: 'Detalles de la Empresa',
    products: 'Productos',
    enrichWithAI: 'Enriquecer con IA',
    enriching: 'Enriqueciendo...',
    enrichSuccess: 'Datos de la empresa enriquecidos exitosamente con IA',
    enrichError: 'Error al enriquecer los datos de la empresa',
    websiteUrl: 'Sitio Web',
    industry: 'Industria',
    selectIndustry: 'Selecciona industria',
    industries: {
      technology: 'Tecnología',
      healthcare: 'Salud',
      finance: 'Finanzas',
      retail: 'Comercio Minorista',
      manufacturing: 'Manufactura',
      other: 'Otro',
    },
    companySize: 'Tamaño de la Empresa',
    selectSize: 'Selecciona tamaño',
    employees: 'empleados',
    address: 'Dirección',
    contactEmail: 'Email de Contacto',
    contactEmailRequired: 'El correo de contacto es obligatorio',
    contactEmailInvalid: 'Ingresa un correo electrónico válido',
    positioning: 'Posicionamiento de Mercado',
    positioningRequired: 'El posicionamiento de mercado es obligatorio',
    positioningPlaceholder: '¿Cómo se posiciona tu empresa en el mercado?',
    problemSolved: 'Problema Resuelto',
    problemSolvedRequired: 'El problema que resuelves es obligatorio',
    problemSolvedPlaceholder: '¿Qué problema central resuelve tu empresa?',
    valueProposition: 'Propuesta de Valor',
    valuePropositionRequired: 'La propuesta de valor es obligatoria',
    valuePropositionPlaceholder: '¿Qué valor único ofrece tu empresa?',
    objectives: 'Objetivos de Negocio',
    objectivesRequired: 'Los objetivos de negocio son obligatorios',
    objectivesPlaceholder: '¿Cuáles son tus principales objetivos de negocio?',
    addProduct: 'Agregar Producto',
    noProducts: 'No hay productos agregados. Haz clic en "Agregar Producto" para comenzar.',
    productName: 'Nombre del Producto',
    productNamePlaceholder: 'ej., Panel de Analíticas',
    productDescription: 'Descripción',
    productDescriptionPlaceholder: 'Breve descripción del producto',
    productCategory: 'Categoría',
    productCategoryPlaceholder: 'ej., SaaS, Software, Servicio',
    back: 'Atrás',
    complete: 'Completar Onboarding',
    onboardingCompleted: '¡Bienvenido! Tu espacio de trabajo está listo.',
    errorCompleting: 'Error al completar el onboarding',
    websiteUrlRequired: 'El sitio web es obligatorio',
    industryRequired: 'La industria es obligatoria',
    companySizeRequired: 'El tamaño de la empresa es obligatorio',
    addressRequired: 'La dirección es obligatoria',
  },
}
